import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import StorageUIApp from "./App";
import { TerminalProvider } from "./contexts/TerminalContext";

const useStyles = makeStyles({
	root: {
		width: "100%",
		flex: 1,
		minHeight: 0,
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
	}
});

const StorageUIPage = () => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<TerminalProvider>
				<StorageUIApp />
			</TerminalProvider>
		</div>
	);
};

export default StorageUIPage;
